export const billingsKeys = {
    all: ['billings'] as const,
    lists: () => [...billingsKeys.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...billingsKeys.lists(), { filters }] as const,
    details: () => [...billingsKeys.all, 'detail'] as const,
    detail: (id: string) => [...billingsKeys.details(), id] as const,
    invalidateList: () => ({
        queryKey: ['billings', 'list'],
        exact: false,
    }),
    create: 'create-billing',
} as const;
